import { map, reject } from "lodash/fp";

import GoogleMeetLogo from "@readai/common/assets/GoogleMeetLogo@2x.png";
import MobileLogo from "@readai/common/assets/ReadMobileLogo@2x.png";
import TeamsLogo from "@readai/common/assets/TeamsLogoNoBackground.png";
import WebexLogo from "@readai/common/assets/WebexLogo@2x.png";
import ZoomLogo from "@readai/common/assets/ZoomLogoRounded@2x.png";
import type { ConferencingMeetingPlatform } from "@readai/common/types";

export interface ConferencingPlatform {
  id: ConferencingMeetingPlatform;
  icon: string;
  deprecated: boolean;
  displayName: string;
  displayNameShort: string;
}

export const CONFERENCING_PLATFORMS_BY_ID: Readonly<{
  [key in ConferencingMeetingPlatform]: ConferencingPlatform;
}> = {
  meet: {
    id: "meet",
    icon: GoogleMeetLogo,
    deprecated: false,
    displayName: "Google Meet",
    displayNameShort: "Meet",
  },
  teams: {
    id: "teams",
    icon: TeamsLogo,
    deprecated: false,
    displayName: "Microsoft Teams",
    displayNameShort: "Teams",
  },
  webex: {
    id: "webex",
    icon: WebexLogo,
    /**
     * webex is no longer a supported meeting platform for *new* meetings,
     * but we still need this here for backwards compatibility on old meetings
     * */
    deprecated: true,
    displayName: "Webex",
    displayNameShort: "Webex",
  },
  zoom: {
    id: "zoom",
    icon: ZoomLogo,
    deprecated: false,
    displayName: "Zoom",
    displayNameShort: "Zoom",
  },
  mobile: {
    id: "mobile",
    icon: MobileLogo,
    deprecated: false,
    displayName: "Read App",
    displayNameShort: "Read",
  },
};

export const CONFERENCING_PLATFORMS: Readonly<ConferencingPlatform[]> = [
  CONFERENCING_PLATFORMS_BY_ID.meet,
  CONFERENCING_PLATFORMS_BY_ID.teams,
  CONFERENCING_PLATFORMS_BY_ID.webex,
  CONFERENCING_PLATFORMS_BY_ID.zoom,
  CONFERENCING_PLATFORMS_BY_ID.mobile,
];

export const SUPPORTED_CONFERENCING_PLATFORMS: Readonly<
  ConferencingPlatform[]
> = reject({ deprecated: true }, CONFERENCING_PLATFORMS);

export const CONFERENCING_MEETING_PLATFORMS: Readonly<
  ConferencingMeetingPlatform[]
> = map("id", CONFERENCING_PLATFORMS);
